module.exports = __webpack_public_path__ + "media/images/de-cf16b1b66abc0caadc40a0da0caddaa8.svg";